import React from 'react';
const bonuses = [{
  num: 'BONO 1',
  icon: '🌙',
  title: 'NOCHES DE ORO',
  description: 'El sistema exacto para que tu bebé duerma 8 horas seguidas. Rutinas probadas mes a mes.',
  oldPrice: '$57',
  newPrice: '✅ GRATIS'
}, {
  num: 'BONO 2',
  icon: '🧠',
  title: 'PEQUEÑO GENIO',
  description: '52 micro-actividades científicas para disparar el IQ de tu bebé. Solo 5 minutos al día.',
  oldPrice: '$37',
  newPrice: '✅ GRATIS'
}, {
  num: 'BONO 3',
  icon: '📅',
  title: 'TU BEBÉ MES A MES',
  description: 'El mapa completo de hitos, alertas y ventanas de desarrollo. Nunca más adivines.',
  oldPrice: '$27',
  newPrice: '✅ GRATIS'
}, {
  num: 'BONO 4',
  icon: '💰',
  title: 'Ahorra $2000 en su Primer Año',
  description: 'La lista definitiva de lo que NO debes comprar y por qué. Ahorra miles en el primer año.',
  oldPrice: '$17',
  newPrice: '✅ GRATIS'
}];
export function BonusesSection() {
  return <section className="bg-white py-16 px-5" data-id="element-22">
      <div className="max-w-[900px] mx-auto" data-id="element-23">
        <div className="text-center mb-2.5" data-id="element-24">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-25">
            Incluido Gratis Hoy
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4 leading-tight text-center" data-id="element-26">
          Tus 4 Bonos Exclusivos
        </h2>

        <p className="text-lg text-[#6B4C3B] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-27">
          Valorados en $138. Tuyos completamente gratis al adquirir el protocolo
          hoy.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mt-2.5" data-id="element-28">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-gradient-to-br from-[#FAF7F2] to-[#F0E8DE] rounded-2xl p-6 border-2 border-transparent transition-all hover:border-[rgba(183,110,121,0.3)] hover:-translate-y-1 hover:shadow-xl text-center relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-[#B76E79] before:to-[#C9A96E]" data-id="element-29">
              <span className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-[11px] font-bold px-3 py-1 rounded-full mb-4 font-sans tracking-wide" data-id="element-30">
                {bonus.num}
              </span>
              <div className="text-5xl mb-3.5" data-id="element-31">{bonus.icon}</div>
              <h3 className="text-xl text-[#3D2B1F] mb-2 font-bold" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-sm text-[#6B4C3B] font-sans leading-relaxed mb-3.5" data-id="element-33">
                {bonus.description}
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-34">
                <span className="text-sm text-gray-400 line-through font-sans" data-id="element-35">
                  {bonus.oldPrice}
                </span>
                <span className="text-base font-bold text-green-700 font-sans" data-id="element-36">
                  {bonus.newPrice}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}